import styled from "styled-components";

export const AccordionContainer = styled.div`
  border: none;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;

  & .accordion-summary {
    display: flex;
    justify-content: space-between;
    align-items: center;

    cursor: pointer;
    background-color: #ffffff;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #efe9fe;
    }
  }

  & .accordion-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

  & .accordion-details {
    display: none;
  }

  &.expanded .accordion-details {
    display: block;
  }
`;
